import { AccountOperations } from '@shared/commons/AccountOperations';
import { Resources } from '@shared/localizations/Resources';
import { StatementTableColumnId } from './StatementTableColumns';
import { formatTruncatePriceWithoutCurrency } from '../../Formatters/AssetFormatter';
import { DateTimeUtils } from '../../Time/DateTimeUtils';
const formatAmount = (statement) => {
    const amount = statement.getAmount();
    const account = statement.getAccount();
    const asset = account.getAsset();
    if (!isNullOrUndefined(asset)) {
        formatTruncatePriceWithoutCurrency(amount, asset);
    }
    return isValidNumber(amount) ? amount.toString() : '';
};
const formatOperationType = (statement) => {
    const operationTypeId = statement.getOperationTypeId();
    return isValidNumber(operationTypeId)
        ? Resources.getResource(AccountOperations.getTypeLocalizationKey(operationTypeId))
        : statement.getOperationType();
};
export function getStatementValue(statement, columnId) {
    switch (columnId) {
        case StatementTableColumnId.Account:
            return statement.getAccountId();
        case StatementTableColumnId.Symbol:
            return statement.getSymbol();
        case StatementTableColumnId.Date:
            return statement.getDate();
        case StatementTableColumnId.OperationType:
            return statement.getOperationType();
        case StatementTableColumnId.OperationId:
            return statement.getOperationId();
        case StatementTableColumnId.Amount:
            return statement.getAmount();
        case StatementTableColumnId.OpenPrice:
            return statement.getOpenPrice();
        case StatementTableColumnId.ClosePrice:
            return statement.getClosePrice();
        case StatementTableColumnId.Quantity:
            return statement.getQuantity();
        case StatementTableColumnId.Currency:
            return statement.getCurrency();
        case StatementTableColumnId.PosOpeningDate:
            return statement.getPosOpeningDate();
        case StatementTableColumnId.PositionId:
            return statement.getPositionId();
        case StatementTableColumnId.TradeId:
            return statement.getTradeId();
        case StatementTableColumnId.Details:
            return statement.getDetails();
        default:
            return null;
    }
}
export function getFormattedStatementValue(statement, columnId) {
    const rawValue = getStatementValue(statement, columnId);
    if (rawValue === null || rawValue === undefined) {
        return '';
    }
    switch (columnId) {
        case StatementTableColumnId.Date:
        case StatementTableColumnId.PosOpeningDate:
            return rawValue instanceof Date && rawValue.getTime() > 0 ? DateTimeUtils.FormatToDate(rawValue) : '';
        case StatementTableColumnId.Amount:
            return formatAmount(statement);
        case StatementTableColumnId.OperationType:
            return formatOperationType(statement);
        default:
            return rawValue.toString();
    }
}
;
